export const LANDING_PAGE_OPTIONS = [
  { key: 'dashboard_page', label: 'Dashboard', path: '/dashboard' },
  { key: 'live_tracking_page', label: 'Live Tracking', path: '/tracking' },
  { key: 'media_page', label: 'Media', path: '/media' },
  { key: 'media_event_videos', label: 'Media — Event Videos', path: '/media?tab=events', parent: 'media_page' },
  { key: 'media_live_videos', label: 'Media — Live Videos', path: '/media?tab=streams', parent: 'media_page' },
  { key: 'media_remote_downloads', label: 'Media — Remote Media', path: '/media?tab=downloads', parent: 'media_page' },
  { key: 'media_shared_evidence', label: 'Media — Shared Evidence', path: '/media?tab=shared', parent: 'media_page' },
  { key: 'analytics_page', label: 'Analytics', path: '/analytics' },
  { key: 'analytics_history', label: 'Analytics — History', path: '/analytics?tab=history', parent: 'analytics_page' },
  { key: 'analytics_events', label: 'Analytics — Events', path: '/analytics?tab=events', parent: 'analytics_page' },
  { key: 'analytics_alerts', label: 'Analytics — Alerts', path: '/analytics?tab=alerts', parent: 'analytics_page' },
  { key: 'analytics_reports', label: 'Analytics — Reports', path: '/analytics?tab=reports', parent: 'analytics_page' },
  { key: 'geofencing_page', label: 'Geofencing', path: '/geofencing' },
  { key: 'geofencing_zones', label: 'Geofencing — Zones', path: '/geofencing?tab=zones', parent: 'geofencing_page' },
  { key: 'geofencing_places', label: 'Geofencing — Places', path: '/geofencing?tab=places', parent: 'geofencing_page' },
  { key: 'geofencing_routes', label: 'Geofencing — Routes', path: '/geofencing?tab=routes', parent: 'geofencing_page' },
  { key: 'people_page', label: 'People', path: '/people' },
  { key: 'people_drivers', label: 'People — Drivers', path: '/people?tab=drivers', parent: 'people_page' },
  { key: 'people_staff', label: 'People — Staff', path: '/people?tab=staff', parent: 'people_page' },
  { key: 'people_passengers', label: 'People — Passengers', path: '/people?tab=passengers', parent: 'people_page' },
  { key: 'people_driver_corrections', label: 'People — Driver Corrections', path: '/people?tab=driver-corrections', parent: 'people_page' },
  { key: 'fleet_page', label: 'Fleet', path: '/fleet' },
  { key: 'fleet_vehicles', label: 'Fleet — Vehicles', path: '/fleet?tab=vehicles', parent: 'fleet_page' },
  { key: 'fleet_trailers', label: 'Fleet — Trailers', path: '/fleet?tab=trailers', parent: 'fleet_page' },
  { key: 'fleet_equipment', label: 'Fleet — Equipment', path: '/fleet?tab=equipment', parent: 'fleet_page' },
  { key: 'fleet_maintenance', label: 'Fleet — Maintenance', path: '/fleet?tab=maintenance', parent: 'fleet_page' },
  { key: 'fleet_fuel', label: 'Fleet — Fuel', path: '/fleet?tab=fuel', parent: 'fleet_page' },
  { key: 'operations_page', label: 'Operations', path: '/operations' },
  { key: 'operations_asset_booking', label: 'Operations — Asset Booking', path: '/operations?tab=booking', parent: 'operations_page' },
  { key: 'operations_pre_checklist', label: 'Operations — Pre-Checklist', path: '/operations?tab=checklist', parent: 'operations_page' },
  { key: 'operations_reporting', label: 'Operations — Reporting & Compliance', path: '/operations?tab=reporting', parent: 'operations_page' },
  { key: 'chat_page', label: 'Chat', path: '/chat' },
  { key: 'my_contact_page', label: 'My Contact', path: '/my-contact' },
  { key: 'installation_page', label: 'Installation', path: '/installation' },
  { key: 'settings_page', label: 'Settings', path: '/settings' },
  { key: 'settings_general', label: 'Settings — General', path: '/settings?tab=general', parent: 'settings_page' },
  { key: 'settings_notifications', label: 'Settings — Notifications', path: '/settings?tab=notifications', parent: 'settings_page' },
  { key: 'settings_integrations', label: 'Settings — Integrations', path: '/settings?tab=integrations', parent: 'settings_page' },
  { key: 'settings_sub_accounts', label: 'Settings — Sub Accounts', path: '/settings?tab=sub_accounts', parent: 'settings_page' },
  { key: 'admin_panel_page', label: 'Admin Panel', path: '/admin-panel' },
  { key: 'admin_user_management', label: 'Admin Panel — User Management', path: '/admin-panel?tab=users', parent: 'admin_panel_page' },
  { key: 'admin_device_management', label: 'Admin Panel — Device Management', path: '/admin-panel?tab=devices', parent: 'admin_panel_page' },
  { key: 'admin_commands', label: 'Admin Panel — Commands', path: '/admin-panel?tab=commands', parent: 'admin_panel_page' },
  { key: 'admin_tenant_isolation_audit', label: 'Admin Panel — Tenant Isolation Audit', path: '/admin-panel?tab=isolation-audit', parent: 'admin_panel_page' },
  { key: 'admin_impersonation_audit', label: 'Admin Panel — Impersonation Audit', path: '/admin-panel?tab=impersonation-audit', parent: 'admin_panel_page' },
  { key: 'admin_global_audit_log', label: 'Admin Panel — Audit Log', path: '/admin-panel?tab=audit-log', parent: 'admin_panel_page' },
  { key: 'admin_feature_management', label: 'Admin Panel — Feature Management', path: '/admin-panel?tab=features', parent: 'admin_panel_page' },
  { key: 'admin_system_settings', label: 'Admin Panel — System Settings', path: '/admin-panel?tab=system', parent: 'admin_panel_page' },
];

export const isLandingPageAllowedByKeys = (option, enabledKeys = []) => {
  const enabled = new Set(enabledKeys);
  return enabled.has(option.key) && (!option.parent || enabled.has(option.parent));
};

export const getAllowedLandingPageOptions = (enabledKeys = []) => (
  LANDING_PAGE_OPTIONS.filter((option) => isLandingPageAllowedByKeys(option, enabledKeys))
);

export const getFallbackLandingPageKey = (enabledKeys = []) => {
  const allowed = getAllowedLandingPageOptions(enabledKeys);
  if (allowed.some((option) => option.key === 'dashboard_page')) return 'dashboard_page';
  return allowed[0]?.key || null;
};

export const getAllowedLandingPageKeysFromFeatures = (features) => {
  const enabledKeys = [];
  Object.entries(features?.pages || {}).forEach(([key, value]) => {
    if (value === true) enabledKeys.push(key);
  });
  Object.entries(features?.subpages || {}).forEach(([key, value]) => {
    if (value === true) enabledKeys.push(key);
  });
  return enabledKeys;
};

export const getLandingPath = (landingPageKey, features) => {
  const enabledKeys = getAllowedLandingPageKeysFromFeatures(features);
  const option = LANDING_PAGE_OPTIONS.find((item) => item.key === landingPageKey);
  if (option && isLandingPageAllowedByKeys(option, enabledKeys)) return option.path;

  const fallbackKey = getFallbackLandingPageKey(enabledKeys);
  if (!fallbackKey) return null;
  return LANDING_PAGE_OPTIONS.find((item) => item.key === fallbackKey)?.path || null;
};